import { CTA_GRADIENT } from '@/features/billboards/constants/detailTheme';

type DetailStateProps = {
  onBackHome?: () => void;
  embedded?: boolean;
};

/* Modified by: Ishan | Soft-contrast detail loading state */
export function DetailLoadingState({ embedded = false }: DetailStateProps) {
  return (
    <div
      className={`flex items-center justify-center bg-[#F3F2F9] ${
        embedded ? 'min-h-[50vh]' : 'min-h-screen'
      }`}
    >
      <div className="h-9 w-9 animate-spin rounded-full border-2 border-[#EAE8F5] border-t-[#8156B4]" />
    </div>
  );
}

/* Modified by: Ishan | Soft-contrast detail not found state */
export function DetailNotFoundState({
  onBackHome,
  embedded = false,
}: DetailStateProps) {
  return (
    <div
      className={`flex flex-col items-center justify-center gap-4 bg-[#F3F2F9] px-6 ${
        embedded ? 'min-h-[50vh]' : 'min-h-screen'
      }`}
    >
      <p className="text-lg font-bold text-[#3A3660]">Screen not found</p>
      <button
        type="button"
        onClick={onBackHome}
        className="cursor-pointer rounded-full px-5 py-2.5 text-sm font-bold text-white shadow-sm hover:opacity-95 transition"
        style={{ background: CTA_GRADIENT }}
      >
        {embedded ? 'Back to screens' : 'Back to home'}
      </button>
    </div>
  );
}
